// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__34PLM","info":"UpdateTermsInfo_info__24cQV"};